import Ico from "../components/Icons";
import useReveal from "../hooks/useReveal";

const VALUES = [
  { ico:"shield", t:"Fiabilité & transparence",  s:"Des engagements tenus, des délais respectés et des devis sans surprise, à chaque étape du projet." },
  { ico:"zap",    t:"Livraison rapide garantie", s:"Vos projets livrés dans les temps, sans compromis sur la qualité, grâce à un processus rodé." },
  { ico:"users",  t:"Accompagnement long terme", s:"Un partenariat durable, pas une simple prestation ponctuelle : on reste à vos côtés après la livraison." },
  { ico:"cpu",    t:"Solutions sur-mesure",      s:"Chaque solution est pensée pour votre contexte, votre budget et vos objectifs — jamais de copier-coller." },
];

const TIMELINE = [
  { y:"2023", t:"Naissance de Layetech", d:"L'aventure démarre à Dakar avec une conviction simple : chaque commerce local mérite les mêmes outils numériques que les grandes entreprises." },
  { y:"2024", t:"Premiers clients fidèles", d:"Une dizaine de commerces et PME nous font confiance pour leur site web, leur maintenance informatique et leur présence Google." },
  { y:"2025", t:"Lancement du Pack Business Pro", d:"Pour répondre à la demande, nous lançons une offre tout-en-un combinant site, gestion, branding et visibilité en une seule solution." },
  { y:"2026", t:"Plus de 15 entreprises accompagnées", d:"Layetech continue de grandir avec de nouveaux services (automatisation, conseil digital) tout en gardant un accompagnement de proximité." },
];

export default function About() {
  useReveal();

  return (
    <div className="pagewrap">
      <section className="sec" style={{ background: "var(--off)" }}>
        <div className="secinr">
          <div className="aboutgrid">
            <div className="r">
              <div className="lbl"><span className="lblline" />Qui sommes-nous</div>
              <h2 className="sh2">Layetech accompagne les entreprises vers la <em>transformation digitale.</em></h2>
              <p className="slead" style={{ marginTop: "1rem" }}>Basée à Dakar, Layetech est née d'une conviction : chaque commerce local mérite les mêmes outils que les grandes entreprises, sans jargon technique ni prix inaccessibles.</p>
              <p className="slead" style={{ marginTop: "1rem" }}>Ce qui a commencé par des interventions de dépannage informatique s'est transformé, projet après projet, en un accompagnement digital complet : sites web, logiciels de gestion, visibilité Google et stratégie marketing. Aujourd'hui, notre équipe réunit des compétences techniques, créatives et commerciales pour porter chaque client, de la boutique de quartier à la PME multi-sites.</p>
              <p className="slead" style={{ marginTop: "1rem" }}>Notre approche reste la même depuis le premier jour : écouter avant de proposer, livrer vite et bien, et rester disponibles longtemps après la mise en ligne.</p>
              <div className="statsrow">
                {[["10+", "Clients accompagnés"], ["3 ans", "D'expérience"], ["100%", "Satisfaction"]].map(([v, l]) => (
                  <div className="stat" key={l}>
                    <div className="statval">{v}</div>
                    <div className="statlbl">{l}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="valcards r" style={{ transitionDelay: ".15s" }}>
              {VALUES.map((v, i) => (
                <div className="valc" key={v.t} style={{ transitionDelay: `${i * .06}s` }}>
                  <div className="valico"><Ico name={v.ico} size={19} color="#fff" /></div>
                  <div className="valtxt"><strong>{v.t}</strong><span>{v.s}</span></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* MISSION / VISION */}
      <section className="sec" style={{ background: "var(--w)" }}>
        <div className="secinr">
          <div className="sechdr r">
            <div className="lbl"><span className="lblline" />Notre raison d'être</div>
            <h2 className="sh2">Mission & <em>vision</em></h2>
          </div>
          <div className="missionrow r" style={{ transitionDelay: ".05s" }}>
            <div className="missionc">
              <h3><Ico name="zap" size={18} color="var(--blue)" />Notre mission</h3>
              <p>Rendre la digitalisation accessible à chaque commerce et chaque PME sénégalaise, en proposant des solutions concrètes, abordables et adaptées à la réalité du terrain — pas des outils génériques importés tels quels.</p>
            </div>
            <div className="missionc">
              <h3><Ico name="sparkle" size={18} color="var(--blue)" />Notre vision</h3>
              <p>Devenir le partenaire digital de référence pour les entreprises locales à Dakar et au Sénégal, reconnu pour la qualité de son accompagnement autant que pour la performance de ses solutions.</p>
            </div>
          </div>
        </div>
      </section>

      {/* TIMELINE */}
      <section className="sec" style={{ background: "var(--off)" }}>
        <div className="secinr">
          <div className="sechdr r">
            <div className="lbl"><span className="lblline" />Notre parcours</div>
            <h2 className="sh2">Quelques <em>étapes clés</em></h2>
          </div>
          <div className="timeline r" style={{ transitionDelay: ".1s" }}>
            {TIMELINE.map(t => (
              <div className="tlitem" key={t.y}>
                <div className="tlyear">{t.y}</div>
                <div className="tlt">{t.t}</div>
                <p className="tld">{t.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}